import { Chip } from '@mui/material';
import styled from 'styled-components';

export const StyledBadge = styled(Chip)`
  && {
    height: unset;
    background: ${({ theme }) => theme.palette.background.default};
    ${({ theme }) => theme.typography.p9};
    color: ${({ theme }) => theme.palette.text.secondary};
    border: 1px solid ${({ theme }) => theme.palette.stroke.primary};
    padding: 0.25rem 0.375rem;
    border-radius: ${({ theme }) => theme.shape.tooltipRadius};

    span {
      padding: 0;
    }
  }
`;
